'use client';

import { IconList } from '@/components/ui/icons';

export const ChannelsParts = ({
  width,
  height,
  unread,
  active,
}: {
  width: string;
  height: string;
  unread: boolean;
  active: boolean;
}) => {
  return (
    <div className='relative flex h-[3rem] w-[3.5rem] justify-center'>
      {unread && (
        <span className='absolute right-0 top-0.5 z-10 block size-2.5 rounded-full bg-kl-red' />
      )}
      <IconList width={width} height={height} className={active ? '' : 'opacity-50'} />
    </div>
  );
};
